export default __webpack_public_path__ + "static/media/expl-gradcam_14_DE.42ae1f4b.png";